import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { T } from "@/constants/testIds";

export default function LatestArticles() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/articles?limit=6").then((r) => setItems(r.data.items || [])).catch(() => setItems([]));
  }, []);

  return (
    <section data-testid={T.latestArticles} className="py-24 sm:py-32">
      <div className="container-editorial">
        <div className="flex items-end justify-between gap-4 mb-12">
          <div>
            <span className="eyebrow">The library</span>
            <h2 className="heading-2 mt-3">Latest articles and reflections.</h2>
          </div>
          <Link to="/articles" className="hidden sm:inline text-sm uppercase tracking-widest hover:text-forest">
            All articles →
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-14">
          {items.map((a, i) => (
            <Link
              key={a.id}
              to={`/articles/${a.slug}`}
              data-testid={T.articleCard(a.slug)}
              className="group flex flex-col"
            >
              <div className="flex items-center gap-3 text-[11px] uppercase tracking-widest text-ink-muted">
                <span className="text-forest">{a.category}</span>
                <span className="h-1 w-1 rounded-full bg-ink-muted/40" />
                <span>{a.reading_time_min} min read</span>
              </div>
              <h3 className="font-serif text-2xl sm:text-[26px] mt-3 text-ink leading-snug group-hover:text-forest transition-colors" style={{ fontWeight: 500 }}>
                {a.title}
              </h3>
              <p className="text-[15px] mt-4 text-ink-muted leading-relaxed">{a.summary}</p>
              <div className="mt-6 pt-4 border-t border-border text-xs text-ink-muted flex items-center justify-between">
                <span>{a.author_name}</span>
                {a.reviewer_name && <span>Reviewed by {a.reviewer_name}</span>}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
